/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metrics_Type_Ecosystem_LongInputs */



/**
* | output |
* | --- |
* | "Blockchain ecosystem" |
*
* @param {Metrics_Type_Ecosystem_LongInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const metrics_type_ecosystem_long = /** @type {((inputs?: Metrics_Type_Ecosystem_LongInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metrics_Type_Ecosystem_LongInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Blockchain ecosystem")
});